import { CostType } from "src/services/interfaces/calculator/CostType";
import * as moment from 'moment';
import { IPricingCalculatorRequest } from 'src/services/interfaces/calculator/IPricingCalculatorRequest';
import { CalculationRequestTypeEnum } from 'src/services/interfaces/calculator/CalculationRequestTypeEnum';


export function MapEmptyPricingRequest(calculationRequestType?: CalculationRequestTypeEnum): IPricingCalculatorRequest {
  const priceCalculatorRequest: IPricingCalculatorRequest = {
    calculationRequestType: calculationRequestType ?? null,
    price: 0,
    spread: 0,
    precatorio: {
      principal: 0,
      interest: 0,
      correctionType: undefined,
      baseDate: moment(),
      court: undefined,
      issueDate: moment(),
      type: undefined,
      processCodeSource: undefined,
      processCode: undefined,
      cpfCnpj: undefined,
      credorBirthDate: undefined
    },
    pricingParameters: {
      commission: 0,
      disbursementCost: 0,
      pss: 0,
      pssAbsolute: 0,
      isPss: false,
      cost: 0,
      spreadGrossUp: 0,
      isSpreadGrossUp: false,
      pdd: 0,
      manualPdd: false,
      manualCost: false,
      isManualSettlementMonth: false,
      manualSettlementMonth: 0,
      isManualMaturityDate: false,
      manualMaturityDate: moment(),
      costType: CostType.percentualCost,
      reducedPercentLender: 1,
      isReducedPercentLender: false,
      disbursementDate: moment(),
      settlementCost: 0,
      cashflows: [],
      commissionValue: 0,
      updatedPrecatorioValue: 0,
      spreadWithoutPdd: 0,
      funding: null
    }
  };
  return priceCalculatorRequest;
}



// WEBPACK FOOTER //
// ./src/pages/ferramentas/manual-calculation/MapEmptyPricingRequest.tsx